import React from 'react';
import styled from 'styled-components';
import { fontSize, minBreakpointQuery, sectionMargins } from '../styles';
import { Container, Heading, Button } from './ui';

const StyledIconContentCards = styled.section`
  ${sectionMargins()};
`;

const StyledHeader = styled.header`
  text-align: center;
  margin-bottom: 30px;

  ${minBreakpointQuery.small`
    margin-bottom: 45px;
  `}

  ${minBreakpointQuery.large`
    margin-bottom: 60px;
  `}
`;

const StyledText = styled.p`
  text-align: center;
  margin-top: 20px;

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    ${fontSize(18)};
    margin-top: 30px;
  `}
`;

const StyledItems = styled.div`
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
  gap: 40px;

  ${minBreakpointQuery.tsmall`
    gap: 50px;
  `}

  ${minBreakpointQuery.medium`
    row-gap: 60px;
  `}
`;

const StyledItem = styled.div`
  text-align: center;

  ${minBreakpointQuery.tsmall`
    width: calc((100% - 50px) / 2);
  `}

  ${minBreakpointQuery.medium`
    width: calc((100% - 100px) / 3);
  `}
`;

const StyledItemIcon = styled.img`
  height: 50px;
  width: 50px;

  ${minBreakpointQuery.smedium`
    height: 60px;
    width: 60px;
  `}

  ${minBreakpointQuery.large`
    height: 70px;
    width: 70px;
  `}
`;

const StyledItemHeading = styled.h3`
  margin-top: 20px;
  ${fontSize(18)};

  ${minBreakpointQuery.small`
    margin-top: 25px;
  `}

  ${minBreakpointQuery.large`
    ${fontSize(20)};
  `}
`;

const StyledItemText = styled.p`
  margin-top: 10px;
  ${fontSize(14)};

  ${minBreakpointQuery.small`
    margin-top: 15px;
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(16)};
  `}
`;

const StyledItemButton = styled(Button)`
  margin-top: 20px;
  padding: 10px 25px;
  ${fontSize(14)};

  ${minBreakpointQuery.small`
    margin-top: 30px;
  `}

  ${minBreakpointQuery.medium`
    ${fontSize(16)};
  `}
`;

const IconContentCards = ({ heading, text, items }) => (
  <StyledIconContentCards>
    <Container>
      <StyledHeader>
        <Heading>{heading}</Heading>
        {text && <StyledText>{text}</StyledText>}
      </StyledHeader>
      <StyledItems>
        {items.map(({ icon, heading, text, link }, id) => (
          <StyledItem key={id}>
            <StyledItemIcon src={icon.url} alt={icon.alt} loading="lazy" />
            <StyledItemHeading>{heading}</StyledItemHeading>
            {text && <StyledItemText>{text}</StyledItemText>}
            {link && (
              <StyledItemButton to={link.pageUrl}>{link.text}</StyledItemButton>
            )}
          </StyledItem>
        ))}
      </StyledItems>
    </Container>
  </StyledIconContentCards>
);

export default IconContentCards;
